import DateRangePicker from "components/commons/date-range-picker";
import Drawer from "components/commons/drawer";
import { TABLE_EVENT_SETTING } from "configs/work-settings/configTableEvent";
import moment from "moment";
import icEditPrimary from "../../../assets/images/ic-edit-04-primary.svg";
import icFilter from "../../../assets/images/ic-filter-new.svg";
import icAddSquare from "../../../assets/images/id-add-square.svg";
import { ACTION_TYPE } from "../../../constants/constant";
import Button from "../../commons/button";
import DeleteModal from "../../commons/delete-modal";
import Search from "../../commons/search";
import Table from "../../commons/table";
import Toast from "../../commons/toast";
import ViewList from "../../commons/view-list";
import { EventForm } from "./EventForm";
import { formatDateMoment } from "utils/utils";


export const Event = (
    {
        dataList,
        modal,
        isShowToast,
        toastMessage,
        eventDetail,
        previewEvent,
        isLoading,
        onClickItemHandler,
        clearToast,
        query,
        isCreating,
        isUpdating,
        isDeleting,
        actionType,
        onChangeQuery,
        setShowModal,
        onDelete,
        onChangeValue,
        onSubmitForm,
        errorForm
    }) => {

    return (
        <div className={"flex flex-col"}>
            <div className={"flex justify-between px-6 py-4"}>
                <div className={"flex space-x-7"}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({search: key, page: 1})}/>
                    <div className={"flex gap-x-3"}>
                        <div className={"flex items-center gap-2"}>
                            <img src={icFilter} alt="ic-filter"/>
                            <p className="text-neutral-70">Filter by date:</p>
                            <DateRangePicker
                                value={query?.startDate ? [query?.startDate, query?.endDate] : []}
                                onChange={(value) => onChangeQuery({page: 1, startDate: value[0], endDate: value[1]})}
                                format='YYYY-MM-DD'
                                maxDate={`${moment().get('year')}-12-31`}
                            />
                        </div>
                        <ViewList
                            show={modal?.limit}
                            onShow={() => setShowModal({limit: true})}
                            onClose={() => setShowModal({limit: false})}
                            value={query?.limit}
                            onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                        />
                    </div>
                </div>
                <Button title="Tambah Event" icon={icAddSquare}
                        onClick={() => onClickItemHandler({actionType: ACTION_TYPE.CREATE})}/>
            </div>
            <Table
                className="my-3"
                name={TABLE_EVENT_SETTING.name}
                columns={TABLE_EVENT_SETTING.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({page: val})}
                onClickItem={(val) => onClickItemHandler(val)}
                onClickSort={(val) => onChangeQuery(val)}
                loading={isLoading}
            />
            <Drawer visibility={modal?.preview} onHide={() => setShowModal({preview: false})} title="Preview Event">
                <div className={"space-y-5 px-6 pb-16"}>
                    <div className={"flex items-center justify-between"}>
                        <div className={"font-bold text-md text-neutral-80 capitalize"}>{previewEvent?.name || '-'}</div>
                        <Button 
                            type="outline" 
                            icon={icEditPrimary} 
                            title="edit" 
                            onClick={() => onClickItemHandler({item: previewEvent, actionType: ACTION_TYPE.EDIT})}
                        />
                    </div>
                    <div className="space-y-5">
                        <div className="flex">
                            <div className={"w-32 text-neutral-70 pr-2"}>Tanggal Event</div>
                            <div
                                className={"flex-1 font-medium text-neutral-80"}>{formatDateMoment(previewEvent?.date, 'D MMMM YYYY')}</div>
                        </div>
                    </div>
                    <div className="space-y-5">
                        <div className="flex">
                            <div className={"w-32 text-neutral-70 pr-2"}>Created By</div>
                            <div
                                className={"flex-1 font-medium text-neutral-80"}>{previewEvent?.actor}</div>
                        </div>
                    </div>
                    <div className="space-y-5">
                        <div className="flex">
                            <div className={"w-32 text-neutral-70 pr-2"}>Created At</div>
                            <div
                                className={"flex-1 font-medium text-neutral-80"}>{formatDateMoment(previewEvent?.created_at, 'DD/MM/YYYY HH:mm')}</div>
                        </div>
                    </div>
                    <div className={"flex flex-col space-y-5 inner-html"}>
                        <div className="text-neutral-80 font-medium">Deskripsi</div>
                        <div dangerouslySetInnerHTML={{__html: previewEvent?.description}}/>
                    </div>
                </div>
            </Drawer>
            <DeleteModal
                show={modal?.delete}
                onHide={() => setShowModal({delete: false})}
                onDelete={onDelete}
                isLoading={isDeleting}
                text="Apakah anda yakin ingin menghapus data event?"
            />
            {
                modal?.form &&
                <EventForm
                    title={`${actionType === ACTION_TYPE.CREATE ? 'Create' : 'Update'} Event`}
                    show={modal?.form}
                    onHide={() => setShowModal({form: false})}
                    eventDetail={eventDetail}
                    onChangeValue={onChangeValue}
                    errorForm={errorForm}
                    isCreating={isCreating}
                    isUpdating={isUpdating}
                    onSubmitForm={onSubmitForm}
                />
            }
            <Toast
                show={isShowToast}
                message={toastMessage}
                onClose={() => clearToast()}
            />
        </div>
    )
}
